"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.StyledSelectorContainer = exports.Form = void 0;
const button_1 = require("@pulse-web-ui/button");
const containers_1 = require("@pulse-web-ui/containers");
const theme_1 = require("@pulse-web-ui/theme");
exports.Form = (0, theme_1.styled)(containers_1.WidgetContainer) `
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  ${theme_1.media.desktop} {
    row-gap: 24px;
  }
`;
exports.StyledSelectorContainer = theme_1.styled.div `
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-top: 16px;

  ${theme_1.media.desktop} {
    flex-direction: row;
  }
`;
exports.StyledButton = (0, theme_1.styled)(button_1.Button) `
  ${theme_1.typography.regular14};
  line-height: 20px;
  margin-top: 12px;
`;
